import React from 'react';
import { LegalPage } from '../components/LegalPage';
interface PrivacyPageProps {
  language: 'en' | 'es';
}
export function PrivacyPage({
  language
}: PrivacyPageProps) {
  const content = {
    en: {
      title: 'PRIVACY POLICY',
      sections: [{
        heading: '1. INFORMATION WE COLLECT',
        paragraphs: ['We collect information you provide directly: Name, phone number, email address, service address, type of service requested, and rental dates.', 'We also collect automatically: IP address, browser type, pages visited, date and time of visit.']
      }, {
        heading: '2. HOW WE USE YOUR INFORMATION',
        paragraphs: ['To process and confirm your rental reservation, contact you about your service, send quotes and invoices, improve our website and services, and comply with legal obligations.', 'We do NOT sell your personal information.']
      }, {
        heading: '3. HOW WE SHARE YOUR INFORMATION',
        paragraphs: ['With service providers who assist our operations, law enforcement when required by law, and professional advisors (legal, accounting).']
      }, {
        heading: '4. DATA RETENTION',
        paragraphs: ['We retain your information for as long as necessary, typically no longer than 3 years after your last transaction.']
      }, {
        heading: '5. YOUR RIGHTS',
        paragraphs: ['Access your personal information, request correction of inaccurate data, request deletion of your data, and opt out of marketing communications.', 'Contact: blackstonerentals.99@gmail.com']
      }, {
        heading: '6. COOKIES',
        paragraphs: ['Our website uses cookies to improve your browsing experience. You can disable cookies in your browser settings.']
      }, {
        heading: "7. CHILDREN'S PRIVACY",
        paragraphs: ['Our services are not directed to children under 13. We do not knowingly collect information from children.']
      }, {
        heading: '8. CHANGES TO THIS POLICY',
        paragraphs: ['We may update this Privacy Policy periodically. Changes will be posted on our website.']
      }, {
        heading: '9. CONTACT US',
        paragraphs: ['Blackstone Rentals LLC — Odessa, Texas', 'Phone: 432-528-7892 | 432-803-4737', 'Email: blackstonerentals.99@gmail.com', 'Available 24/7']
      }]
    },
    es: {
      title: 'POLÍTICA DE PRIVACIDAD',
      sections: [{
        heading: '1. INFORMACIÓN QUE RECOPILAMOS',
        paragraphs: ['Recopilamos información que nos proporciona: Nombre, teléfono, correo electrónico, dirección del servicio, tipo de servicio y fechas de renta.', 'También automáticamente: Dirección IP, tipo de navegador, páginas visitadas, fecha y hora de visita.']
      }, {
        heading: '2. CÓMO USAMOS SU INFORMACIÓN',
        paragraphs: ['Para procesar y confirmar su reservación, comunicarnos sobre su servicio, enviar cotizaciones y facturas, mejorar nuestro sitio y servicios, y cumplir con obligaciones legales.', 'NO vendemos su información personal.']
      }, {
        heading: '3. CÓMO COMPARTIMOS SU INFORMACIÓN',
        paragraphs: ['Con proveedores de servicios, autoridades cuando lo requiera la ley, y asesores profesionales (legales, contables).']
      }, {
        heading: '4. RETENCIÓN DE DATOS',
        paragraphs: ['Conservamos su información el tiempo necesario, generalmente no más de 3 años después de su última transacción.']
      }, {
        heading: '5. SUS DERECHOS',
        paragraphs: ['Acceder a su información personal, solicitar corrección de datos inexactos, solicitar eliminación de sus datos, y cancelar comunicaciones de marketing.', 'Contacto: blackstonerentals.99@gmail.com']
      }, {
        heading: '6. COOKIES',
        paragraphs: ['Nuestro sitio usa cookies para mejorar su experiencia. Puede desactivarlas en la configuración de su navegador.']
      }, {
        heading: '7. PRIVACIDAD DE MENORES',
        paragraphs: ['Nuestros servicios no están dirigidos a menores de 13 años.']
      }, {
        heading: '8. CAMBIOS A ESTA POLÍTICA',
        paragraphs: ['Podemos actualizar esta Política periódicamente. Los cambios se publicarán en nuestro sitio.']
      }, {
        heading: '9. CONTÁCTENOS',
        paragraphs: ['Blackstone Rentals LLC — Odessa, Texas', 'Teléfono: 432-528-7892 | 432-803-4737', 'Email: blackstonerentals.99@gmail.com', 'Disponible 24/7']
      }]
    }
  };
  const t = content[language];
  return <LegalPage language={language} title={t.title} lastUpdated="January 1, 2026" sections={t.sections} data-id="element-409" />;
}